import { render, staticRenderFns } from "./CurrencyRateWidgetSmall.vue?vue&type=template&id=6847968f&"
import script from "./CurrencyRateWidgetSmall.vue?vue&type=script&lang=js&"
export * from "./CurrencyRateWidgetSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports